import { render, staticRenderFns } from "./Guarantees.vue?vue&type=template&id=cc0c3a32&"
import script from "./Guarantees.vue?vue&type=script&lang=js&"
export * from "./Guarantees.vue?vue&type=script&lang=js&"
import style0 from "./Guarantees.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports